import { createContext, useContext } from "react";

import type { SelectorOptions } from "./shared.ts";

type ChildNodeSlottingContext = {
  openSelector: (args: SelectorOptions) => void;
};

export const ChildNodeSlottingContext = createContext<ChildNodeSlottingContext | undefined>(undefined);

export const useNodeTypeSelector = () => {
  const context = useContext(ChildNodeSlottingContext);

  if (!context) {
    throw new Error(`Expected ChildNodeSlottingContextProvider in ancestor component`);
  }

  return context;
};
